import { Box, Typography } from '@material-ui/core'
// material
import { styled } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
// components
import Logo from '../components/Logo'
import { LANDING_PAGE_URL } from '../constants'
import GenesusName from '../components/GenesusName'

// ----------------------------------------------------------------------

// Split auth screen: a quiet brand panel (top on small screens, left from md up)
// and the form column. Pages pass their form content as children.
const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.background.default,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}))

const BrandPanel = styled('aside')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.neutral,
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.up('md')]: {
    flex: '0 0 42%',
    maxWidth: 560,
    minHeight: '100vh',
    justifyContent: 'space-between',
    padding: theme.spacing(6, 7),
    borderBottom: 'none',
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}))

const ContentStyle = styled('main')(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(5, 3),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(8, 6),
  },
}))

// ----------------------------------------------------------------------

AuthLayout.propTypes = {
  children: PropTypes.node,
}

export default function AuthLayout({ children }) {
  return (
    <RootStyle>
      <BrandPanel>
        <Box
          component="a"
          href={LANDING_PAGE_URL}
          aria-label="Lidya Genomics"
          sx={{ display: 'inline-flex', alignSelf: 'flex-start', textDecoration: 'none' }}
        >
          <Logo sx={{ width: { xs: 132, md: 168 }, height: 'auto' }} />
        </Box>

        <Box sx={{ maxWidth: 400 }}>
          <Typography variant="h3" component="p" sx={{ mb: { xs: 0.5, md: 1.5 } }}>
            <GenesusName />
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            NGS analysis for genome and exome data: germline, somatic, carrier and CNV.
          </Typography>
        </Box>

        <Typography variant="caption" sx={{ display: { xs: 'none', md: 'block' }, color: 'text.secondary' }}>
          © {new Date().getFullYear()} Lidya Genomics
        </Typography>
      </BrandPanel>

      <ContentStyle>
        <Box sx={{ width: '100%', maxWidth: 400 }}>{children}</Box>
      </ContentStyle>
    </RootStyle>
  )
}
